import React, { Component } from 'react';
import { FieldArray } from 'formik';
import moment from 'moment';
import ModalComponent from '../../../ui/Modal';

class ListingDiscountComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deleteIndex: null,
      modalOpen: false,
      showExpiredDiscounts: false
    }

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.renderReadOnlyWrapper = this.renderReadOnlyWrapper.bind(this);
  }

  openModal(index) { this.setState({ modalOpen: true, deleteIndex: index }); }
  closeModal() { this.setState({ modalOpen: false }); }

  toggleExpiredDiscounts = () => { this.setState({ showExpiredDiscounts: !this.state.showExpiredDiscounts }) }

  cloneDiscount = (discount, clearDates) => {
    let clonedDiscount = Object.assign({}, discount);
    clonedDiscount._id = null;
    if (clearDates) this.clonedDiscount.validDates = [];
    else clonedDiscount.validDates = clonedDiscount.validDates.map(vd => Object.assign({}, vd));
    this.props.onDiscountEdit(clonedDiscount);
  }

  renderBody() {
    return (<div>
      <div className="col-12">
        Are you sure you want to permanently delete this discount?
      </div>
    </div>)
  }

  renderButtonRow = (discount, values) => {
    let { onDiscountRemove } = this.props;
    return (
      <div className="w-100 row align-items-center m-0">
        <div className="col text-center pl-0">
          <label onClick={() => this.closeModal()}>Cancel</label>
        </div>
        <div className="col text=center">
          <button className='btn btn-primary' onClick={(e) => {
            e.preventDefault();
            onDiscountRemove(discount, values);
            this.closeModal();
          }}>Delete</button>
        </div>
      </div>
    )
  }

  renderDiscount = (discount) => {
    if (discount.discountType === 'Percentage')
      return <div>{discount.discountPercentage}% off</div>
    else if (discount.discountType === 'DollarAmount')
      return <div>${discount.discountDollarAmount} off</div>

    return null;
  }

  renderReadonly = (index, discount, disabled, values) => {
    let { onDiscountEdit } = this.props;
    let validDates = '';

    discount.validDates.forEach((obj, i) => {
      let startDate = moment(obj.startDate).format('MM/DD/YYYY');

      validDates = `${validDates}${startDate}`;

      if (obj.endDate !== null) {
        let endDate = moment(obj.endDate).format('MM/DD/YYYY');
        validDates = `${validDates} - ${endDate}`;
      }

      validDates = `${validDates}, `
    });
    validDates = validDates.replace(/,\s*$/, "");

    return (
      <div key={`discount-readonly-${index}`} className={!disabled ? "discounts" : "discounts disabled"}>
        <h6 className={disabled ? "disabled" : null}>
          <div className="col-12">
            {!disabled ? discount.name : `[EXPIRED] ${discount.name}`}
            {!disabled ?
              <i className="fas fa-times" onClick={() => {
                this.openModal(index);
              }}></i>
              : null}
          </div>
        </h6>
        <div className="row">
          <div className="col-12 col-md-8">
            <div className="fieldgroup row description">
              <div className="col-12">
                <b>{discount.code}</b>&nbsp;
                {!disabled ? <span className="copy-code-link" onClick={() => { navigator.clipboard.writeText(discount.code) }}>Copy Code</span> : null}
              </div>
            </div>
            <div className="fieldgroup row price">
              <div className="col-12">
                {this.renderDiscount(discount)}
              </div>
            </div>
            <div className="fieldgroup row valid-dates last">
              <div className="date-div">
                <b>Valid Dates:</b>&nbsp;<span>{validDates === '' ? "N/A" : validDates}</span>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-4 button-container">
            <div>{!disabled
              ? (<span className="duplicate-link" onClick={() => { this.cloneDiscount(discount); }}>
                <i className="fa fa-clone duplicate-link-icon"></i>&nbsp;&nbsp;Duplicate Code</span>)
              : (<span className="duplicate-link" onClick={() => { this.cloneDiscount(discount, true); }}>
                <i className="fa fa-history duplicate-link-icon"></i>&nbsp;&nbsp;Restore Code</span>)
            }</div>
            {!disabled && <div><button className="btn-secondary mx-auto float-right mt-2" onClick={(e) => {
              e.preventDefault();
              onDiscountEdit(discount);
            }}>Edit</button></div>}
          </div>
        </div>
        {this.state.modalOpen && this.state.deleteIndex === index && (<ModalComponent
          id="ConfirmationModal"
          title="Delete Discount"
          noMinHeight={true}
          body={this.renderBody()}
          footer={this.renderButtonRow(discount, values)}
          onClose={this.closeModal} />)}
      </div>
    )
  }

  renderReadOnlyWrapper(values) {
    if (values.discounts !== undefined && values.discounts.length > 0)
      return values.discounts.map((discount, index) => {
        let dateInRange = false;
        if (discount.validDates) {
          let validDate = discount.validDates.find(d => moment(d.startDate).isSameOrAfter(moment(), 'd') ||
            (d.endDate && moment(d.endDate).isSameOrAfter(moment(), 'd')));
          if (validDate || discount.validDates.length === 0) { dateInRange = true; }
        }
        return !dateInRange ? null : this.renderReadonly(index, discount, false, values);
      })

    return null;
  }

  render() {
    let { onDiscountEdit, values, showExpired } = this.props;

    return (<FieldArray name="discounts" render={() => (
      <div>
        <h5>Discounts (optional)</h5>
        <div>
          If you'd like to offer discounts to renters, you can create discount codes and share
          them via messaging. Renters will input the code during the booking process.
        </div>
        <br />
        <div>
          Discount % or $ will be applied to the nightly rate, excluding
          cleaning fee, pet fee, add-ons and taxes.
        </div>
        <br />
        {this.renderReadOnlyWrapper(values)}
        <div className="row">
          <div className="col-12">
            <label className="create-discount-link" onClick={() => {
              onDiscountEdit();
            }}>+ Create another Discount</label>
          </div>
        </div>
        {showExpired && (<div className="expired-addons">
          <div className="row">
            <div className="col-12">
              <div className="row" onClick={() => this.toggleExpiredDiscounts()}>
                <div className="col-6">
                  <h5 className="expired-text">Expired Discounts</h5>
                </div>
                <div className="col-6">
                  <i className={`fa ${!this.state.showExpiredDiscounts ? "fa-angle-right" : "fa-angle-down"} expired-arrow`}></i>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  {this.state.showExpiredDiscounts && values.discounts.map((d, i) => {
                    if (d.validDates.length === 0) return null;
                    let dateInRange = d.validDates.find(vd => moment(d.startDate).isSameOrAfter(moment(), 'd') || (d.endDate && moment(d.endDate).isSameOrAfter(moment(), 'd')));
                    if (dateInRange) return null;

                    return <div key={`expired-discounts-${i}`}>
                      <div>
                        <hr className="horizontal-line" />
                        {this.renderReadonly(i, d, true, values)}
                      </div>
                    </div>
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
        )}
      </div>
    )} />
    )
  }
}

export default ListingDiscountComponent;
